import React, { useEffect, useState } from 'react';
import { Tabs, Button, Table, Tag, Space, Card } from 'antd';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import Statuses from '../../modules/Status/Statuses';
import { RoleList } from '../Role/RoleList';
import DiscountRate from '../DiscountRate/DiscountRate';
import ToolList from '../../components/Tools/ToolList';
import ParameterList from '../../components/Parameters/ParameterList';
import OfferingList from '../../components/Offerings/OfferingList';
import ProposalListWithDetails from '../../components/ProjectFollowUp/ProposalList';
import ProposalList from '../../components/Proposal/ProposalList';
import CustomerProposalList from '../../components/Proposal/CustomerProposalList';
import { hasRole } from '../../utils';

const { TabPane } = Tabs;

const ProjectFollowUp: React.FC = () => {
  // "proposal.show" iznini kontrol etmek için permissions state
  const [permissions, setPermissions] = useState<string[]>([]);
  const [activeKey, setActiveKey] = useState('1');
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const isCustomer = hasRole('CUSTOMER');

  const handleTabChange = (key: string) => {
    setActiveKey(key);
    const nextParams = new URLSearchParams(searchParams);
    nextParams.set('tab', key);
    nextParams.delete('search');
    setSearchParams(nextParams, { replace: true });
  };

  useEffect(() => {
    // permissions'ı localStorage'dan okuyup parse ediyoruz
    const storedPermissions = localStorage.getItem('permissions');
    if (storedPermissions) {
      try {
        const parsedPermissions = JSON.parse(storedPermissions);

        // Eğer JSON içeriği gerçekten bir array ise set et
        if (Array.isArray(parsedPermissions)) {
          setPermissions(parsedPermissions);
        } else {
          console.error('Permissions hatalı formatta:', parsedPermissions);
        }
      } catch (err) {
        console.error('Permissions parse hatası:', err);
      }
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    // URL'den veya navigation state'ten başlangıç sekmesini oku
    const qTab = searchParams.get('tab');
    const stateTab = (location.state as any)?.tab;
    const next = (qTab || stateTab || '').toString();
    if (['1','2','3','4','5'].includes(next)) {
      setActiveKey(next);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, location.state]);

  return (
    <div className='mb-60px'>
      {isLoading ? (
        <div>Loading...</div>
      ) : isCustomer ? (
        <CustomerProposalList defaultStatusIds={[4, 5, 6, 7, 10]} type={2} />
      ) : permissions.includes('proposal.show') ? (
        // proposal.show izni varsa, sekmeli yapıyı göster
        <Tabs
          activeKey={activeKey}
          onChange={handleTabChange}
          className="custom-tabs"
          tabBarStyle={{ borderBottom: 'none' }}
          destroyInactiveTabPane
        >
          <TabPane
            tab={
              <Button
                type={activeKey === '1' ? 'primary' : 'default'}
                className="d-button tab-button"
              >
                Sözleşme
              </Button>
            }
            key="1"
          >
            <ProposalListWithDetails defaultStatusIds={[10]} type={1} sortFieldProp={"documentUploadedAt"} sortDirectionProp={"ASC"} initialPageSize={100} />
          </TabPane>

          <TabPane
            tab={
              <Button
                type={activeKey === '2' ? 'primary' : 'default'}
                className="d-button tab-button"
              >
                Planlama
              </Button>
            }
            key="2"
          >
            <ProposalListWithDetails defaultStatusIds={[6]} type={2} sortFieldProp={"requestedPlanningStartDate"} sortDirectionProp={"ASC"} initialPageSize={100} />
          </TabPane>

          <TabPane
            tab={
              <Button
                type={activeKey === '3' ? 'primary' : 'default'}
                className="d-button tab-button"
              >
                Yasal Bildirim (İSG-Katip)
              </Button>
            }
            key="3"
          >
            <ProposalListWithDetails defaultStatusIds={[7]} type={7} sortFieldProp={"approvedPlanningStartDate"} sortDirectionProp={"ASC"} initialPageSize={100} />
          </TabPane>

          <TabPane
            tab={
              <Button
                type={activeKey === '4' ? 'primary' : 'default'}
                className="d-button tab-button"
              >
                Kontrol ve Raporlama
              </Button>
            }
            key="4"
          >
            <ProposalListWithDetails
              defaultStatusIds={[5]}
              type={3}
              sortFieldProp={"approvedPlanningStartDate"}
              sortDirectionProp={"ASC"}
              initialPageSize={100}
              categoryDrawerReadOnly
            />
          </TabPane>

          <TabPane
            tab={
              <Button
                type={activeKey === '5' ? 'primary' : 'default'}
                className="d-button tab-button"
              >
                Kontrol Tamamlandı
              </Button>
            }
            key="5"
          >
            <ProposalListWithDetails
              defaultStatusIds={[4]}
              type={4}
              sortFieldProp={"invoiceDate"}
              sortDirectionProp={"DESC"}
              initialPageSize={100}
              categoryDrawerReadOnly
            />
          </TabPane>
        </Tabs>
      ) : (
        // proposal.show izni yoksa, sadece ProposalList göster
        <>
        <ProposalList defaultStatusIds={[4, 5, 6, 7, 10]} type={2} />
        </>
      )}
    </div>
  );
};

export default ProjectFollowUp;
